import React, { useState } from 'react'
import { Wrapper } from './Styled'
import { SearchResults } from './components/SearchResults'
import { initialValues } from 'data/schema'
import { VoucherForm } from 'core/components/VoucherForm';

import { ReactComponent as Logo } from 'assets/images/dots.svg';
import { Col, Modal, Row, Typography } from 'antd';

const { Text } = Typography;

export const VoucherCreate = (props: any) => {
  const [formType, setFormType] = useState('');
  const [initValues, setInitValues] = useState(initialValues)
  
  const handleClose = () => {
    props.setShow(false);
    setFormType('');
  }
  
  return (
    
    <Modal
      destroyOnClose={true}
      footer={null}
      onCancel={() => props.setShow(false)}
      onOk={handleClose}
      title={(
        <Row justify="space-around" align="middle" style={{fontSize: '18px'}}>
          <Col flex="50px">
            <Logo className='logo' style={{maxWidth: '30px', maxHeight: '30px'}}/>
          </Col>
          <Col flex="auto" style={{textAlign: 'center'}}>
            <Text>Create Voucher</Text>
          </Col>
          <Col flex="50px"></Col>
        </Row>
      )}
      visible={props.show}
      width='90%'
      style={{maxWidth: '1000px'}}
    >
      <div id='modalBody'>
        {formType === '' ? 
          <Wrapper>
            <SearchResults
              dealers={props.dealers}
              setFormType={setFormType}
              setInitValues={setInitValues}
            />
          </Wrapper>
        :
          <VoucherForm
            initValues={initValues}
            handleClose={handleClose}
            formType={formType}
            dealers={props.dealers}
            setDateRange={props.setDateRange}
          />
        }
      </div>
    </Modal>
  )
}
